import { t } from '../i18n';

export function openRulesModal(): void {
  const existing = document.getElementById('rules-modal');
  if (existing) existing.remove();

  const backdrop = document.createElement('div');
  backdrop.id = 'rules-modal';
  backdrop.className = 'modal-backdrop';

  const card = document.createElement('div');
  card.className = 'modal-card';

  card.innerHTML = `
    <div class="modal-header">
      <h2 class="modal-title">${t('rules_title')}</h2>
      <button class="btn-icon" id="btn-close-rules">✕</button>
    </div>
    <div class="modal-body">
      <div style="display: flex; flex-direction: column; gap: 16px;">
        <div style="background: #FAF8F5; border: 1px solid #E5DFD5; border-radius: 10px; padding: 14px;">
          <h3 style="font-size: 15px; font-weight: 700; margin-bottom: 6px; color: #27272A;">
            ${t('rules_tab_cards')}
          </h3>
          <p style="font-size: 13px; color: #52525B;">${t('rules_deck_overview')}</p>
        </div>

        <div style="background: #FEF2F2; border: 1px solid #FECACA; border-radius: 10px; padding: 14px;">
          <h3 style="font-size: 15px; font-weight: 700; margin-bottom: 6px; color: #991B1B;">
            ${t('card_corven')} & ${t('card_ezarion')}
          </h3>
          <p style="font-size: 13px; color: #7F1D1D;">${t('rules_corven_slay_desc')}</p>
        </div>

        <div style="background: #FFFBEB; border: 1px solid #FDE68A; border-radius: 10px; padding: 14px;">
          <h3 style="font-size: 15px; font-weight: 700; margin-bottom: 6px; color: #92400E;">
            ${t('rules_tab_bit_it')}
          </h3>
          <p style="font-size: 13px; color: #78350F;">${t('rules_bit_it_ladder')}</p>
        </div>

        <div style="background: #F0FDF4; border: 1px solid #BBF7D0; border-radius: 10px; padding: 14px;">
          <h3 style="font-size: 15px; font-weight: 700; margin-bottom: 6px; color: #166534;">
            ${t('rules_tab_tiebreaks')}
          </h3>
          <p style="font-size: 13px; color: #14532D;">${t('rules_tiebreak_desc')}</p>
        </div>

        <div style="background: #F0F9FF; border: 1px solid #BAE6FD; border-radius: 10px; padding: 14px;">
          <h3 style="font-size: 15px; font-weight: 700; margin-bottom: 6px; color: #075985;">
            ${t('scoreboard_title')}
          </h3>
          <p style="font-size: 13px; color: #0C4A6E;">${t('rules_binary_desc')}</p>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button class="btn-action btn-face" id="btn-confirm-rules">${t('btn_close')}</button>
    </div>
  `;

  backdrop.appendChild(card);
  document.body.appendChild(backdrop);

  const close = () => backdrop.remove();
  card.querySelector('#btn-close-rules')?.addEventListener('click', close);
  card.querySelector('#btn-confirm-rules')?.addEventListener('click', close);
  backdrop.addEventListener('click', (e) => {
    if (e.target === backdrop) close();
  });
}
